import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ContactListComponent } from './contact-list.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgSelectModule } from '@ng-select/ng-select';
import { DetailInfoTypeModule } from 'shared/detail-info-type/detail-info-type.module';
import { DetailInfoFormPageStepsModule } from 'shared/detail-info-form-page-steps/detail-info-form-page-steps.module';
import { AlertModule } from 'ngx-bootstrap/alert';
import { ListColumnFilterModule } from 'shared/list-column-filter/list-column-filter.module';

@NgModule({
    declarations: [
        ContactListComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        BsDropdownModule,
        NgSelectModule,
        AlertModule.forRoot(),
        DetailInfoTypeModule,
        DetailInfoFormPageStepsModule
    ],
    exports: [ContactListComponent],
    providers: []
})

export class AttendanceContactListModule { }
